import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "textbook-upload"
};
const _hoisted_2 = {
  class: "textbook-upload-main"
};
const _hoisted_3 = {
  slot: "footer",
  class: "dialog-footer"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "pagination-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_UploadFile = _resolveComponent("UploadFile");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_card = _resolveComponent("el-card");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dialog, {
    title: $data.dialogTitle,
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.dialogVisible = $event),
    width: "600px",
    "append-to-body": "",
    onClosed: $options.resetForm
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
      model: $data.formData,
      rules: $data.rules,
      ref: "formRef",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "所属分类",
        prop: "allCategory"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.formData.allCategory,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formData.allCategory = $event),
          options: $data.cascaderOptions,
          props: {
            children: 'options',
            label: 'label',
            value: 'value'
          },
          onChange: $options.getFormUnitData
        }, null, 8, ["modelValue", "options", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "所属目录",
        prop: "directoryCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.formData.directoryCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formData.directoryCode = $event),
          options: $data.formUnitData,
          props: {
            children: 'childDirectoryVoList',
            label: 'directoryName',
            value: 'directoryCode',
            checkStrictly: true,
            emitPath: false
          }
        }, null, 8, ["modelValue", "options"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "作业名称",
        prop: "homeworkName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formData.homeworkName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formData.homeworkName = $event),
          placeholder: "请输入作业名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "作业上传",
        prop: "homeworkFile"
      }, {
        default: _withCtx(() => [_createVNode(_component_UploadFile, {
          ref: "homeworkFile",
          modelValue: $data.formData.homeworkFileList,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formData.homeworkFileList = $event),
          multiple: false,
          "is-show-tip": false,
          limit: 1
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" 上传作业 ", -1)]))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "答案上传",
        prop: "answerFile"
      }, {
        default: _withCtx(() => [_createVNode(_component_UploadFile, {
          ref: "answerFile",
          modelValue: $data.formData.answerFileList,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formData.answerFileList = $event),
          multiple: false,
          "is-show-tip": false,
          limit: 1
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" 上传答案 ", -1)]))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])), [[_directive_loading, $data.formLoading || $data.isloading]]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[5] || (_cache[5] = $event => $options.submitForm('formRef'))
    }, {
      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("确定", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      onClick: _cache[6] || (_cache[6] = $event => $data.dialogVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("取消", -1)]))]),
      _: 1
    })])]),
    _: 1
  }, 8, ["title", "modelValue", "onClosed"]), _createVNode(_component_el_card, {
    style: {
      "height": "100%"
    }
  }, {
    header: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
      inline: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.cascaderSelect,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.cascaderSelect = $event),
          options: $data.cascaderOptions,
          props: {
            children: 'options',
            label: 'label',
            value: 'value'
          },
          onChange: $options.handleSelectChange,
          clearable: "",
          placeholder: "请选择作业分类",
          style: {
            "width": "400px"
          }
        }, null, 8, ["modelValue", "options", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.searchForm.directoryCode,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.searchForm.directoryCode = $event),
          options: $data.unitData,
          props: {
            children: 'childDirectoryVoList',
            label: 'directoryName',
            value: 'directoryCode',
            checkStrictly: true,
            emitPath: false
          },
          onChange: $options.handleNodeClick,
          clearable: "",
          placeholder: "请选择作业目录",
          style: {
            "width": "400px"
          }
        }, null, 8, ["modelValue", "options", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.searchForm.approveStatus,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.searchForm.approveStatus = $event),
          placeholder: "请选择发布状态",
          clearable: "",
          onChange: $options.handleSearchChange,
          style: {
            "width": "180px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "未发布",
            value: "0"
          }), _createVNode(_component_el_option, {
            label: "已发布",
            value: "1"
          })]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $options.addFile
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("新增文件", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    })])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "page-size": $data.table.listQuery.pageSize,
      "current-page": $data.table.listQuery.pageNo,
      total: $data.table.total,
      onCurrentChange: $options.changePage
    }, null, 8, ["page-size", "current-page", "total", "onCurrentChange"])])]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.table.list,
      border: "",
      style: {
        "width": "100%"
      },
      height: "100%"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        type: "index"
      }), _createVNode(_component_el_table_column, {
        prop: "homeworkName",
        label: "作业名称",
        "min-width": "120"
      }), _createVNode(_component_el_table_column, {
        prop: "typeName",
        label: "作业类型",
        width: "100"
      }), _createVNode(_component_el_table_column, {
        prop: "rangeTypeName",
        label: "学段",
        width: "80"
      }), _createVNode(_component_el_table_column, {
        prop: "gradeName",
        label: "年级",
        width: "80"
      }), _createVNode(_component_el_table_column, {
        prop: "courseName",
        label: "课程名称",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        prop: "textbookName",
        label: "教材名称",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        prop: "directoryName",
        label: "教材目录",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        label: "作业",
        "min-width": "120"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", {
          onClick: $event => $options.handleDownload(scope.row.homeworkFile, scope.row.homeworkFileName),
          class: "text-link"
        }, _toDisplayString(scope.row.homeworkFileName), 9, _hoisted_4)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "答案",
        "min-width": "120"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", {
          onClick: $event => $options.handleDownload(scope.row.answerFile, scope.row.answerFileName),
          class: "text-link"
        }, _toDisplayString(scope.row.answerFileName), 9, _hoisted_5)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "approveStatus",
        label: "发布状态",
        width: "80"
      }, {
        default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.approveStatus === '0' ? '未发布' : '已发布'), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "操作",
        width: "220"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => $options.handlePublish(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.approveStatus === '0' ? '发布' : '取消发布'), 1)]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "success",
          size: "small",
          onClick: $event => $options.editFile(scope.row)
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("编辑", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "danger",
          size: "small",
          onClick: $event => $options.handleDelete(scope.row)
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("删除", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  })])]);
}